import { AppTypes, LOAD_DATA_REQUEST, LOAD_DATA_SUCCESS, SET_TRUCK, SET_VIEWER_API, SET_SIMULATION_SELECT, SET_ACTIVE_SIMULATION, SET_ACTIVE_SIMULATION_STEP, SimulationType, SET_ACTIVE_SIMULATION_TYPE, SET_SIMULATION_SIDE_ACTIVE, END_ACTIVE_SIMULATION, RESTART_SIMULATION, SET_POSITION_READY, GO_TO_NEXT_SIMULATION, SET_AVSP, SET_CONTENT_OPENED, SET_NEXT_SIM_STEP } from "../types/app"
import Viewer from "../components/Scene/viewer";
import { Truck, Simulation } from "types/data";
import config from "config";

export const loadDataStart = (): AppTypes => 
  ({
    type: LOAD_DATA_REQUEST
  })

export const setTruck = (truck: Truck): AppTypes => 
  ({
    type: SET_TRUCK,
    payload: truck
  })

export const loadData = (): AppTypes => 
  ({
    type: LOAD_DATA_SUCCESS,
    payload: config
  })

export const setViewerApi = (viewerApi: Viewer): AppTypes => 
  ({
    type: SET_VIEWER_API,
    viewerApi
  })

export const setSimulationSelect = (simulationSelectActive: Boolean): AppTypes => 
  ({
    type: SET_SIMULATION_SELECT,
    simulationSelectActive
  })

export const setActiveSimulation = (payload: Simulation | undefined): AppTypes => 
  ({
    type: SET_ACTIVE_SIMULATION,
    payload
  })

export const setActiveSimulationStep = (payload: number): AppTypes => 
  ({
    type: SET_ACTIVE_SIMULATION_STEP,
    payload
  })

export const setActiveSimulationType = (payload: SimulationType): AppTypes => 
  ({
    type: SET_ACTIVE_SIMULATION_TYPE,
    payload
  })

export const setSimulationSidePanelActive = (payload: Boolean): AppTypes => 
  ({
    type: SET_SIMULATION_SIDE_ACTIVE,
    payload
  })

export const endActiveSimulation = (): AppTypes => 
  ({
    type: END_ACTIVE_SIMULATION
  })

export const restartSimulation = (): AppTypes => 
  ({
    type: RESTART_SIMULATION
  })

export const setPositionReady = (ready: Boolean): AppTypes => 
  ({
    type: SET_POSITION_READY,
    payload: ready
  })

export const goToNextSimulation = (): AppTypes => 
  ({
    type: GO_TO_NEXT_SIMULATION
  })

export const setAVSP = (payload: Boolean): AppTypes => 
  ({
    type: SET_AVSP,
    payload
  })

export const setContentOpened = (payload: Boolean): AppTypes => 
  ({
    type: SET_CONTENT_OPENED,
    payload
  })

export const setNextSimulationStep = (): AppTypes => 
  ({
    type: SET_NEXT_SIM_STEP
  })